import React, { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import TTLayout from "./layouts/TTLayout";
import AdminLayout from "./layouts/AdminLayout";
import withClearCache from "./ClearCache";
import { RfcLibraryProvider } from "./components/RfcLibrary/RfcLibraryContext";
import FileRedirect from "./components/RfcLibrary/FileRedirect";
import RequireAuth from "./components/RfcLibrary/RequireAuth";
//Tour imports
import Joyride, { STATUS, EVENTS, ACTIONS } from 'react-joyride';
import { stopTour, completePsTour, updateTourStatus, setStepIndex } from "./redux/userOnboarding/userOnboardingSlice";
import { ServiceApi } from "./services/index.service";
import { tourStyles } from "./utils/tourConstants";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { handleAuthCallback } from "./api/oidcApi";
import Signout from "./Signout";
import { useOktaAuth } from "@okta/okta-react";
import { DashboardLoader } from "./utils/Loading";

const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}
function MainApp() {
  // if(process.env.REACT_APP_ENVIRONMENT==="PROD"){
  //   console.log = function () {};
  // }
  const { steps, run, stepIndex, showProgress,
    currentTourComponent, continuous, tourStatus } = useSelector((state) => state?.userOnboarding);
  const { profile } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [tourGuideStatus, setTourGuideStatus] = useState('');

  useEffect(() => {
    fetch('/version.json')
      .then(response => response.json())
      .then(data => console.log('last commit and build time: ', data))
      .catch(err => console.log('last commit error: ', err));
  }, []);

  // TourGuideStatus effect
  useEffect(() => {
    if ([STATUS.SKIPPED].includes(tourGuideStatus) || [STATUS.FINISHED].includes(tourGuideStatus)) {
      let serviceapi = new ServiceApi();
      let newTourStatus = { ...tourStatus };
      newTourStatus[currentTourComponent] = true;
      // Update the respective component flag in the backend as finished it's tour and Stop the tour
      serviceapi.updateStatusForTourGuide(newTourStatus, profile?.uid, profile?.user_name)
        .then((tourAPIResponse) => {
          tourAPIResponse?.statusCode === 200 ? dispatch(updateTourStatus(tourAPIResponse?.response?.data?.tourStatus)) : enqueueSnackbar("Something went wrong!", {
            anchorOrigin: { vertical: "top", horizontal: "right", }, variant: "error",
          });
          if (tourAPIResponse?.statusCode === 200 && currentTourComponent === "productionSheets")
            dispatch(completePsTour());
          dispatch(stopTour());
        })
    }
  }, [tourGuideStatus]);

  //Triggers when state of the Tour Guide is changed
  const handleJoyrideCallback = ({ step, status, index, type, action, ...otherProps }) => {
    if (status === STATUS.RUNNING) {
      if (index === 0) window.scrollTo({ top: 0 })
      document.body.style.overflow = "hidden";
      if (([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND]).includes(type)) {
        // Update state to advance the tour
        dispatch(setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1)));
      }
    }
    else document.body.style.overflow = ""
    setTourGuideStatus(status);
  }

  const LoginCallback = () => {
    const { authState } = useOktaAuth();
    useEffect(() => {
      if (authState?.isAuthenticated) {
        return;
      }
      handleAuthCallback();
    }, [authState?.isAuthenticated]);

    return <DashboardLoader />;
  };



  return (
    <>
      {steps?.length > 0 && <Joyride
        steps={steps}
        stepIndex={stepIndex}
        // debug={true}
        continuous={continuous}
        run={run}
        callback={handleJoyrideCallback}
        showProgress={showProgress}
        showSkipButton={true}
        disableOverlayClose={true}
        disableCloseOnEsc={true}
        disableScrolling={true}
        hideCloseButton={true}
        styles={tourStyles}
      />}

      <RfcLibraryProvider>
        <Routes>
          {/* Protect RFC Library route with RequireAuth */}
          {/* <Route path="/rfc-library/:filePath/*" element={<FileRedirect />} /> */}
          <Route path="/rfc-library/:filePath/*" element={
            <RequireAuth>
              <FileRedirect />
            </RequireAuth>
          } />
          <Route path="/treatteam/*" element={<TTLayout />} key={'TTLayout'} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/signout" element={<Signout />} />
          <Route path="/*" element={<AdminLayout />} key={'AdminLayout'} />
        </Routes>
      </RfcLibraryProvider>
    </>
  );
}

export default App;